import { Base } from "@studiometa/js-toolkit";
class AccordionCore extends Base {
  /**
   * Accordion config.
   */
  static config = {
    name: "Accordion",
    emits: ["open", "close"],
    options: {
      autoclose: Boolean,
      item: {
        type: Object,
        default: () => ({})
      }
    }
  };
  /**
   * Synchronize close on open.
   */
  onAccordionItemOpen({ index }) {
    this.$emit("open", this.$children.AccordionItem[index], index);
    if (this.$options.autoclose) {
      this.$children.AccordionItem.filter((el, i) => index !== i).forEach((item) => item.close());
    }
  }
  /**
   * Emit close event.
   */
  onAccordionItemClose({ index }) {
    this.$emit("close", this.$children.AccordionItem[index], index);
  }
}
export {
  AccordionCore
};
//# sourceMappingURL=AccordionCore.js.map
